if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomCloseButton = this.querySelector('[id^="ZoomClose-"]');
        if (this.zoomCloseButton) {
          this.zoomCloseButton.addEventListener('click', this.exitZoom.bind(this));
        }
        this.addEventListener('click', this.onContentClick.bind(this));
      }

      hide() {
        this.exitZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        this.exitZoom();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      // Clicking the enlarged product image toggles a secondary, bigger zoom
      // level instead of closing the modal (see the pointerup handler in
      // global.js's ModalDialog, which excludes this same image target).
      onContentClick(event) {
        if (!event.target.matches('.product-media-modal__content > img')) return;
        event.stopPropagation();
        const image = event.target;
        const zoomed = image.classList.toggle('is-secondary-zoomed');
        this.classList.toggle('is-secondary-zoomed', zoomed);
      }

      exitZoom() {
        this.querySelectorAll('.product-media-modal__content > img.is-secondary-zoomed').forEach((image) => {
          image.classList.remove('is-secondary-zoomed');
        });
        this.classList.remove('is-secondary-zoomed');
      }
    }
  );
}
